import PasswordReset from '@/views/personal/password-reset.vue';
import ValueConfigList from '@/views/config/value-config-list.vue';
import ValueConfigDetail from '@/views/config/value-config-detail.vue';
import ImageTextList from '@/views/config/image-text-list.vue';
import ImageTextDetail from '@/views/config/image-text-detail.vue';
import WeixinConfigDetail from '@/views/config/weixin-config-detail.vue';
import OrderProfitRateList from '@/views/config/order-profit-rate-list.vue';
import FreightList from '@/views/freight/freight-list.vue';
import FreightDetail from '@/views/freight/freight-detail.vue';
import MediaList from '@/views/media/media-list.vue';

export default [
	{
		path: '/config/order-profit-rate-list',
		component: OrderProfitRateList,
		name: 'orderProfitRateList'
	},
    {
		path: '/personal/password-reset',
		component: PasswordReset,
		name: 'passwordReset'
	},
    {
		path: '/config/value-config-list',
		component: ValueConfigList,
		name: 'valueConfigList'
	},
    {
		path: '/config/value-config-detail',
		component: ValueConfigDetail,
		name: 'valueConfigDetail'
	},
    {
		path: '/config/image-text-list',
		component: ImageTextList,
		name: 'imageTextList'
	},
    {
		path: '/config/image-text-detail',
		component: ImageTextDetail,
		name: 'imageTextDetail'
	},
    {
		path: '/config/weixin-config-detail',
		component: WeixinConfigDetail,
		name: 'weixinConfigDetail'
	},
	{
		path: '/freight/freight-list',
		component: FreightList,
		name: 'freightList'
	},
	{
		path: '/freight/freight-detail',
		component: FreightDetail,
		name: 'freightDetail'
	},
	{
		path: '/media/media-list',
		component: MediaList,
		name: 'mediaList'
	},
]